import * as React from 'react';
import { IColumn, IColumnDefs } from '../..';
import { IDataRow } from '../../models/IDataRow';
import styles from '.././TVoSimpleGrid.module.scss';
import { IGridRowProps } from './IGridRowProps';
import { IGridRowState } from './IGridRowState';

export default class GridRow extends React.Component<
  IGridRowProps,
  IGridRowState
> {
  constructor(props: IGridRowProps) {
    super(props);
  }

  public render() {
    let rowCols: IDataRow[] = [];
    const { columns } = this.props.columnDefs;
    for (var i = 0; i < columns.length; i++) {
      var value = this.props.dataItem[columns[i].fieldName];
      var colKey = columns[i].key;
      rowCols.push({
        value: value,
        dataType: columns[i].dataType,
        colKey: colKey,
        colIndex: i,
        fieldName: columns[i].fieldName,
        enableOnRowItemRender: columns[i].enableOnRowItemRender,
        enableOnRowItemClick: columns[i].enableOnRowItemClick
      });
    }
    return (
      <tr className={styles.itemHover}>
        {rowCols.map((d, i) =>
          d.enableOnRowItemClick ? (
            <td key={i}>
              <div className={styles.displayWrapper}>
                <div
                  onClick={this.props.onRowItemClick.bind(
                    this,
                    this.props.columnDefs.dataSourceName,
                    d.colKey,
                    d.fieldName,
                    d.value,
                    this.props.dataItem
                  )}
                  style={
                    d.enableOnRowItemClick
                      ? { cursor: 'pointer' }
                      : { cursor: 'inherit' }
                  }
                >
                  {this.props.onRowItemRender !== undefined &&
                  d.enableOnRowItemRender
                    ? this.props.onRowItemRender(
                        this.props.columnDefs.dataSourceName,
                        d.colKey,
                        d.fieldName,
                        this.props.dataItem
                      )
                    : d.value}
                </div>
              </div>
            </td>
          ) : (
            <td key={i}>
              <div className={styles.displayWrapper}>
                <div
                  style={
                    d.enableOnRowItemClick
                      ? { cursor: 'pointer' }
                      : { cursor: 'inherit' }
                  }
                >
                  {this.props.onRowItemRender !== undefined &&
                  d.enableOnRowItemRender
                    ? this.props.onRowItemRender(
                        this.props.columnDefs.dataSourceName,
                        d.colKey,
                        d.fieldName,
                        this.props.dataItem
                      )
                    : d.value}
                </div>
              </div>
            </td>
          )
        )}
      </tr>
    );
  }
}
